import SubscriptionOptionFull from './components/SubscriptionOptionFull';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
var SubscriptionOption = {
    key: 'subscription',
    titleStringKey: 'optionTitle_premium_subscription',
    searchTermsStringKey: 'optionTitle_premium_subscription',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SubscriptionOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !isControlFeatureEnabled('auth-PremiumDashboard') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
var SubscriptionOptionApril = {
    key: 'subscription_',
    titleStringKey: 'optionTitle_premium_subscription',
    searchTermsStringKey: 'optionTitle_premium_subscription',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SubscriptionOptionFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () {
        return !isControlFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox;
    },
};
export default SubscriptionOption;
export { SubscriptionOptionApril };
//# sourceMappingURL=SubscriptionOption.js.map